module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row form",
    staticStyle: {
      "margin-top": "5%"
    }
  }, [_c('h1', {
    staticClass: "text-xs-center",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("\n      Welcome to the Nigeria Federal Ministry of Health Dashboards\n    ")]), _vm._v(" "), (_vm.$route.query.redirect) ? _c('p', {
    staticClass: "text-center"
  }, [_c('small', {
    staticStyle: {
      "color": "teal"
    }
  }, [_vm._v("Login first to view a dashboard for your location.")])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "text-center"
  }, [_vm._v("Login")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._m(1), _vm._v(" "), _c('p'), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "xs6": "",
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.optionLocations,
      "hide-selected": true,
      "searchable": true,
      "allow-empty": true,
      "show-labels": false,
      "placeholder": "Select location"
    },
    model: {
      value: (_vm.selectedLocation),
      callback: function($$v) {
        _vm.selectedLocation = $$v
      },
      expression: "selectedLocation"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.error) ? _c('p', {
    staticStyle: {
      "border-color": "gray"
    }
  }, [_c('label', {
    staticClass: "red--text"
  }, [_vm._v("Incorrect login details.")])]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "dark": "",
      "color": "green"
    }
  }, [_vm._v("Login")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "img-center img-circle img-reponsive",
    staticStyle: {
      "display": "block",
      "margin": "0 auto"
    },
    attrs: {
      "src": "static/img/login_logo.png",
      "alt": "Coat Of Arms"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('small', [_vm._v("choose a location")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-335f397b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Auth/Login.vue
// module id = 785
// module chunks = 13